import { Link } from "react-router-dom";
import { sources } from "./InfiniteCarousel.mock.data";
import "./InfiniteCarousel.scss";

const InfiniteCarousel = () => {
  const sourcesDoubled = sources.concat(sources);

  return (
    <div className="infinite-carousel">
      <div className="wrapper">
        {sourcesDoubled.map(({ link, logo }, index) => (
          <a
            key={index}
            className="img-wrapper"
            href={link}
            target="_blank"
            rel="noreferrer"
          >
            <img src={logo} alt="logo" />
          </a>
        ))}
      </div>
    </div>
  );
};
export default InfiniteCarousel;
